// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VCardSubtitle = createSimpleFunctional('v-card-subtitle');
//# sourceMappingURL=VCardSubtitle.mjs.map